import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9h8","key":"svg-0"}],["path",{"d":"M8 13h6","key":"svg-1"}],["path",{"d":"M13.5 19.5l-1.5 1.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6","key":"svg-2"}],["path",{"d":"M22 22l-5 -5","key":"svg-3"}],["path",{"d":"M17 22l5 -5","key":"svg-4"}]]

const IconMessage2X = createReactComponent('outline', 'message-2-x', 'Message2X', __iconNode);

export default IconMessage2X;